<template>
  <v-dialog 
    v-model="activeMode"  
    :max-width="oneColumn ? 500 : 800"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-if="id" icon v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>

      <v-btn v-else color="primary" dark fab small v-on="on">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      
      <v-card-text class="mt-2">
        <slot></slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>

        <v-btn 
          color="blue darken-1" 
          text 
          @click="save()"
          :disabled="loading"
          :loading="loading"
        >Сохранить</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog> 
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';

export default {
  name: '',

  props: {
    id: String,
    titleName: String,
    loading: Boolean,
    saveFunc: Function,
    oneColumn: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      activeMode: false,
      isValid: false,
      title: (this.id ? 'Карточка ' : 'Создание ') + this.titleName,
    }
  },

  watch: {
    activeMode(newVal) {
      if (newVal) this.$emit('opened');
    }
  },

  methods: {
    save() {
      this.saveFunc().then(res => {
        if (res) this.closeForm();
      });
    },
    closeForm() {
      this.scrollUp();
      this.activeMode = false;
      this.$emit('closed');
    }
  }
}
</script>